var CancelablePromise = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function CancelablePromise(executor) {
        var _this = this;
        this.cancel = function () { return null; };
        var promise = new Promise(function (resolve, reject) {
            _this.localResolve = resolve;
            _this.localReject = reject;
            return executor(resolve, reject);
        });
        promise.cancel = this.cancel;
        this.promise = promise;
    }
    CancelablePromise.prototype.then = function (onFulfilled, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onRejected) {
        return this.cloneForUpChaining(this.promise.then(onFulfilled, onRejected));
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CancelablePromise.prototype.catch = function (onRejected) {
        return this.cloneForUpChaining(this.promise.catch(onRejected));
    };
    CancelablePromise.prototype.finally = function (onFinally) {
        return this.cloneForUpChaining(this.promise.finally(onFinally));
    };
    CancelablePromise.prototype.resolve = function (value) {
        return this.localResolve(value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CancelablePromise.prototype.reject = function (reason) {
        return this.localReject(reason);
    };
    CancelablePromise.prototype.cloneForUpChaining = function (promise) {
        var returnPromise = new CancelablePromise(function () { return null; });
        returnPromise.cancel = this.cancel;
        promise.cancel = this.cancel;
        returnPromise.promise = promise;
        return returnPromise;
    };
    return CancelablePromise;
}());
export { CancelablePromise };
